import React from 'react';
import { Modal, Col, Button } from 'react-bootstrap';
import l10n from 'localization/LocalizationData';

interface HelpModal {
	show: boolean;
	title: string;
	content: string;
	hide: () => void;
}

export const HelpModal = (props: HelpModal) => {
	return (
		<Modal aria-labelledby='helpModalTitle' show={props.show}>
			<Modal.Header>
				<Modal.Title id='helpModalTitle'>{props.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p className='help-modal-text'>
					{props.content}
				</p>
			</Modal.Body>
			<Modal.Footer className='justify-content-center'>
				<Col xs='auto'>
					<Button className='button-info' onClick={props.hide}>
						{l10n.button_close}
					</Button>
				</Col>
			</Modal.Footer>
		</Modal>
	)
}